module.exports = __webpack_public_path__ + "static/office-01-a92d2c1623dd762d3e2e4c636fa485f9.jpg";